import { SyncWizardLoadingView } from "./SyncWizardLoadingView";
import { SyncWizardStep1 } from "./SyncWizardStep1";
import { SyncWizardStep2 } from "./SyncWizardStep2";
import { SyncWizardStep3 } from "./SyncWizardStep3";
import { SyncWizardStep4 } from "./SyncWizardStep4";
import { SyncWizardStepIndicator } from "./SyncWizardStepIndicator";
import ButtonComponent from "@components/Button";
import {
  SyncWizardProvider,
  useSyncWizardActions,
  useSyncWizardMeta,
  useSyncWizardState,
} from "./SyncWizardContext";
import { useSyncWizardController } from "./useSyncWizardController";

export function SyncWizardModal() {
  const controller = useSyncWizardController();

  return (
    <SyncWizardProvider value={controller}>
      <SyncWizardModalContent />
    </SyncWizardProvider>
  );
}

function SyncWizardModalContent() {
  const state = useSyncWizardState();
  const actions = useSyncWizardActions();
  const { canNext, stepTitles } = useSyncWizardMeta();

  return (
    <div
      className="flex fixed inset-0 z-50 justify-center items-center"
      style={{ backgroundColor: "rgba(0,0,0,0.45)" }}
    >
      <div
        className="flex overflow-hidden flex-col w-full bg-white rounded-2xl shadow-2xl"
        style={{ maxWidth: 580, height: "100vh", fontFamily: "'Figtree', sans-serif" }}
      >
        {!state.confirmed && !state.isSubmitting && (
          <div className="flex items-center justify-between px-6 pt-5 pb-4 border-b border-[#e6e9ef] flex-shrink-0">
            <div>
              <p className="text-[11px] text-[#676879] uppercase tracking-widest mb-0.5">
                Same Item, Multiple Boards
              </p>
              <h2 className="text-[16px] font-semibold text-[#323338]">
                {stepTitles[state.step - 1]}
              </h2>
            </div>
          </div>
        )}

        <div className="flex overflow-hidden flex-col flex-1 px-6 pt-5 pb-4 min-h-0">
          {state.isSubmitting && (
            <div className="overflow-y-auto flex-1 min-h-0">
              <SyncWizardLoadingView loadingProgress={state.loadingProgress} />
            </div>
          )}

          {!state.isSubmitting && !state.confirmed && (
            <div className="flex-shrink-0">
              <SyncWizardStepIndicator current={state.step} total={3} />
            </div>
          )}
          {!state.isSubmitting && !state.confirmed && state.step === 1 && <SyncWizardStep1 />}
          {!state.isSubmitting && !state.confirmed && state.step === 2 && <SyncWizardStep2 />}
          {!state.isSubmitting && !state.confirmed && state.step === 3 && (
            <div className="overflow-y-auto flex-1 min-h-0">
              <SyncWizardStep3 />
            </div>
          )}
          {!state.isSubmitting && !state.confirmed && state.step === 4 && (
            <div className="overflow-y-auto flex-1 min-h-0">
              <SyncWizardStep4 />
            </div>
          )}

          {!state.isSubmitting && state.confirmed && (
            <div className="overflow-y-auto flex-1 min-h-0">
              <SyncWizardStep4 />
            </div>
          )}
        </div>

        {!state.confirmed && !state.isSubmitting && (
          <div className="flex items-center justify-between px-6 py-4 border-t border-[#e6e9ef] flex-shrink-0 bg-[#fafafa]">
            <ButtonComponent
              type="button"
              onClick={actions.handleBack}
              text={state.step === 1 ? "Cancel" : "← Back"}
              kind="secondary"
            />

            <div className="flex gap-2 items-center">
              <div className="flex gap-1.5 mr-2">
                {[1, 2, 3, 4].map((s) => (
                  <div
                    key={s}
                    className="rounded-full transition-all"
                    style={{
                      width: s === state.step ? 16 : 6,
                      height: 6,
                      backgroundColor:
                        s === state.step ? "#0073ea" : s < state.step ? "#00c875" : "#d0d4e4",
                    }}
                  />
                ))}
              </div>

              <ButtonComponent
                type="button"
                onClick={actions.handlePrimaryAction}
                disabled={!canNext}
                text={
                  state.step === 4
                    ? state.submitErrorMessage
                      ? "Try again →"
                      : "Confirm →"
                    : "Next →"
                }
              />
            </div>
          </div>
        )}

        {state.confirmed && (
          <div className="flex justify-center px-6 py-4 border-t border-[#e6e9ef] flex-shrink-0 bg-[#fafafa]">
            <ButtonComponent type="button" text="Done" onClick={actions.handleDone} />
          </div>
        )}
      </div>
    </div>
  );
}
